/**
 * api接口的统一出口
 */

import base from './base';
import user from './user';
import log from './log';
import configure from './configure';
import auth from './auth';
import home from './home';
import usage from './usage';
import common from './common';
import consume from './consume';
import productOperation from './product-operation';
import safetyManagement from './safety-management';
import accessManagement from './access-management';
import oem from './oem';
import applicationManagement from './application-management';
import newsCenter from './news';
import resultManagement from './result-management';
import healthManagement from './health-management';
import dailyOperation from './daily-operation';
import customTag from './custom-tag';
import face from './face';
import living from './living';
import device from './device';
import cloudDisk from './cloud-disk';
import microClassAward from './micro-class-award';
import versionUpdate from './versionUpdate';
import faceCharges from './face-charges';
import notice from './notice';
import studentManage from './student-manage';
import facePayment from './face-payment';
import newPayment from './new-payment';
import brandConfiguration from './brand-configuration';
import configurationAd from './advertising-management';
import menuCustomization from './menu-customization';
import serveActivate from './paid-activation';
import questionnaireSurvey from './questionnaire-survey';
import dailyEvaluation from './daily-evaluation';
import recipesManagement from './recipes-management';
import signInQrcode from './sign-in-qrcode';
import onlinePatrol from './online-patrol';
import kinshipPhone from './kinship-phone';
import questionAnswering from './question-answering';
import equipmentAdvert from './equipment-advertising';
import staff from './staff';
import antiBullying_hws from './anti-bullying-hws';
import antiBullying_dh from './anti-bullying-dh';
import antiBullying_deviceManager from './anti-bullying-deviceManager';
import leaveManagement from './leave-management';

export default {
	base,
	user,
	log,
	configure,
	auth,
	home,
	usage,
	common,
	consume,
	productOperation,
	safetyManagement,
	accessManagement,
	oem,
	applicationManagement,
	newsCenter,
	resultManagement,
	healthManagement,
	dailyOperation,
	customTag,
	face,
	living,
	device,
	cloudDisk,
	microClassAward,
	versionUpdate,
	faceCharges,
	notice,
	studentManage,
	facePayment,
	newPayment,
	brandConfiguration,
	configurationAd,
	menuCustomization,
	serveActivate,
	questionnaireSurvey,
	dailyEvaluation,
	recipesManagement,
	signInQrcode,
	onlinePatrol,
	kinshipPhone,
	questionAnswering,
	equipmentAdvert,
	staff,
	antiBullying_hws,
	antiBullying_dh,
	antiBullying_deviceManager,
	leaveManagement
};
